<template lang="html">
<div class="subpage addrule_edit">
    <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="false" label-position="right" label-width="120px">
        <!-- SEO标题 -->
        <el-form-item label="SEO标题" prop="title">
            <el-input :disabled="disabled" size="medium" class="inpText" v-model="params.seoTitle" placeholder=""></el-input>
        </el-form-item>

        <!-- SEO描述 -->
        <el-form-item label="SEO描述">
            <el-input :disabled="disabled" style="width:400px;" type="textarea" v-model="params.seoDesc"></el-input>
        </el-form-item>

        <!-- 信息属性 -->
        <el-form-item label="信息属性">
            <el-checkbox-group :disabled="disabled" v-model="articleProp" @change="selSheckbox">
                <el-checkbox :label="1">推荐</el-checkbox>
                <el-checkbox :label="2">热门</el-checkbox>
                <el-checkbox :label="3">置顶</el-checkbox>
            </el-checkbox-group>
        </el-form-item>

        <!-- 浏览量 -->
        <el-form-item label="浏览量">
            <el-input-number :disabled="disabled" v-model="params.views" controls-position="right" @change="handleChange" :min="1"></el-input-number>
        </el-form-item>

        <!-- 信息页模板-->
        <el-form-item label="信息页模板">
            <el-input size="medium" :disabled="disabled" class="inpText" v-model="params.modelLink"></el-input>
            不填写则继承栏目设置中的内容模板
        </el-form-item>

        <!-- 自定义链接-->
        <el-form-item label="自定义链接">
            <el-input :disabled="disabled" size="medium" class="inpText" v-model="params.customLink"></el-input>
        </el-form-item>
        <!-- 发布者-->
        <el-form-item label="发布者">
            <el-input :disabled="disabled" size="medium" class="inpText" v-model="params.issuer"></el-input>
        </el-form-item>
        <!-- 发布时间-->
        <el-form-item label="发布时间">
            <el-date-picker :disabled="disabled" v-model="params.data" align="right" type="date" placeholder="默认显示当前日期" :picker-options="pickerOptions">
            </el-date-picker>
        </el-form-item>

    </el-form>
</div>
</template>

<script>
// import { userSeek } from "@/api/account";

export default {
    props: ['article'],
    filters: {
        transPhone: function (e) {
            return e.substr(0, 3) + '****' + e.substr(8, 11);
        }
    },
    data() {
        return {
            disabled:true,
            //时间
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                        picker.$emit('pick', new Date());
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                    }
                }, {
                    text: '一周前',
                    onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                    }
                }]
            },
            value1: '',
            value2: '',
            // 时间end
            checkList: ['选中且禁用', '复选框 A'],
            params: {
                seoTitle: '',
                seoDesc: '',
                summary: '', // 摘要
                views: '', // 浏览量
                modelLink: '', // 信息页模板链接
                customLink: '', // 自定义链接
                issuer: '', //发布者
                data: '', // 日期
                recommendProperty: 0, //推荐
                hotProperty: 0, //热门
                topProperty: 0, //置顶

            },
            articleProp: [],
            rules: {
                companyName: [{
                    required: true,
                    trigger: 'blur'
                }],
                subjectTypeId: [{
                    required: true,
                    trigger: 'blur'
                }],
                industryId: [{
                    required: true,
                    trigger: 'blur'
                }],
                staffSizeId: [{
                    required: true,
                    trigger: 'blur'
                }],
                industryDirectionId: [{
                    required: true,
                    trigger: 'blur'
                }],
                // groupsId:[{
                //    required: true,
                //    trigger: 'blur'
                // }],
                // informationReleaseIds:[{
                //    required: true,
                //    trigger: 'blur'
                // }],
            }
        }
    },
    watch: {
        article: function (e) {
            if (e) {
                this.params = e;
                if (this.params.recommendProperty == 1) {
                    this.articleProp.push(1);
                }
                if (this.params.hotProperty == 1) {
                    this.articleProp.push(2);
                }
                if (this.params.topProperty == 1) {
                    this.articleProp.push(3);
                }
            }
        }
    },
    methods: {
        selSheckbox: function (e) {
            console.log(e);
            this.params.recommendProperty = 0;
            this.params.hotProperty = 0;
            this.params.topProperty = 0;
            for (var i = 0; i < e.length; i++) {
                if (e[i] == 1) {
                    this.params.recommendProperty = 1;
                }
                if (e[i] == 2) {
                    this.params.hotProperty = 1;
                }
                if (e[i] == 3) {
                    this.params.topProperty = 1;
                }
            }
        },
        adminChange: function (e) {
            this.mebList.forEach(item => {
                if (item.id == e) {
                    this.params.founder = item.realName;
                    this.params.founderId = e;
                    this.params.creatorMobilePhoneNumber = item.cellPhone;
                }
            })
        },
        selectChange: function (e) {
            this.params[e.paramsKey] = e.name;
            this.params[e.paramsKey + 'Id'] = e.id;
        },
        allSelect: function (e) {
            this.params[e.paramsKey] = e.id;
            if (e.paramsKey == 'identityTypeId') {
                this.params.identityType = e.name;
            }
        },
        goSeek: function (e) {
            var vues = this;
            userSeek({
                where: e,
                no: 1,
                size: 20
            }).then(res => {
                vues.mebList = [];
                res.userListByWhereList.forEach((item, i) => {
                    if (item.cellPhone) {
                        vues.mebList.push(item);
                    }
                });
            })
        },

        saveReturn: function () {
            var vues = this;
            return new Promise((reslove, reject) => {
                vues.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        if (vues.articleProp == 1) {

                        }
                        reslove(vues.params);
                    } else {
                        reslove(false);
                    }
                })
            })
        }
    },
    created: function () {
        var querys = this.$route.query;
        var vues = this;

        // dicSeek({ code: 'sflx' }).then(res => {
        //   this.selectList1 = res.dataDictionarys;
        // })

    }
}
</script>

<style lang="scss" scoped>
</style>

<style lang="css">
.subpage.addrule_edit .el-input__inner {
    border-radius: 0px !important;
}

.subpage.addrule_edit .el-input-number {
    width: 240px !important;
}

.subpage.addrule_edit .selects {
    width: 240px !important;
}

.subpage.addrule_edit .el-input {
    width: 240px !important;
}
</style>



// WEBPACK FOOTER //
// Subpage2.vue?1d5e2ebe